module.exports = __webpack_public_path__ + "assets/img/mecha-btn-072263e9.png";